import React, { Component } from 'react';

import ReactAudioPlayer from 'react-audio-player';
import vmsg  from "vmsg";
import axios from "axios"
import { ReactMic } from 'react-mic';
import Loader from "../Loader"

const recorder = new vmsg.Recorder({
  wasmURL: "https://unpkg.com/vmsg@0.3.0/vmsg.wasm"
});

export default class Recorder extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
     isLoading: false,
     isRecording: false,
     saving: false,
     recordings: []
    };
  }
  record = async () => {
    this.setState({ isLoading: true });

    if (this.state.isRecording) {
      const blob = await recorder.stopRecording();
      this.setState({
        isLoading: false,
        isRecording: false,
        isSaving: true,
        recordings: this.state.recordings.concat(URL.createObjectURL(blob))
      });
       var xhr=new XMLHttpRequest();
       var that = this
      xhr.onload=function(e) {
          if(this.readyState === 4) {
              console.log("Server returned: ",e.target.responseText);
              that.setState({isSaving: false})
              try{
                that.props.callback()
              } catch(e){
                console.log(e)
              }
          }
      };
      var fd=new FormData();
      console.log(this.state)
      fd.append("audio_data[0]",blob, "audio.mp3");
      Object.keys(this.props.data).map((key)=>{
        let value = this.props.data[key]
        fd.append(key,value)
      })
      xhr.open("POST",this.props.endpoint,true);
      xhr.send(fd);

    } else {
      try {
        await recorder.initAudio();
        await recorder.initWorker();
        recorder.startRecording();
        this.setState({ isLoading: false, isRecording: true });
      } catch (e) {
        console.error(e);
        this.setState({ isLoading: false });
      }
    }
  };
  render() {
    const { isLoading, isRecording, recordings,isSaving } = this.state;
    return (
      <React.Fragment>
        <div className="center">
          {isSaving ? (
            <Loader />
            ) : (
              <button className="btn-floating btn-large" disabled={isLoading} onClick={this.record}>
                    {isRecording ? (
                        <i className="material-icons red">stop</i>
                      ) : (
                        <i className="material-icons green">keyboard_voice</i>
                      )
                    }
              </button>
            )}
        </div>
      </React.Fragment>
    )
  }
}
